import { HeaderColumn } from '@tableau/widgets-datagrid';
import * as React from 'react';

export class GeocodingRecordHeaderFormatter extends React.Component<HeaderColumn.HeaderFormatterProps, {}> {
  public constructor(props: HeaderColumn.HeaderFormatterProps) {
    super(props);
    this.state = {};
  }

  public render(): JSX.Element {
    const props: React.HTMLAttributes<HTMLDivElement> = {
      style: { paddingLeft: 3 },
    };
    return (
      <div {...props}>
        {this.props.col.name}
      </div>
    );
  }
}
